import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ContextService} from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';


import { Utils } from '../../../utils/utils';
import * as fromModel from '../../services/models';
import { Constant } from '../../../environments/constants';

import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';
import { FramePrefix } from 'msal/lib-commonjs/utils/Constants';


@Component({
  selector: 'gp-edit-expense',
  templateUrl: './edit-expense.component.html',
  styleUrls: ['./edit-expense.component.scss']
})
export class EditExpenseComponent implements OnInit, OnDestroy {

  form: FormGroup;
  mode = "edit";
  validationMsg='';

  expense: fromModel.Expense;
  goalType: fromModel.GOALTYPE;
  goalTypeDesc: string;
  goal: fromModel.Goal;
  infRate;
  
  startTypes: fromModel.CodeValue[];
  endTypes: fromModel.CodeValue[];
  expenseTypes: fromModel.CodeValue[];
  goalTypes: fromModel.CodeValue[];
  
  constructor(private contextService: ContextService,
    private dataService: DataService,
    private refDataService: RefDataService,
    private currencyPipe: CurrencyPipe,    
    private readonly fb: FormBuilder,
    private dialogRef: MatDialogRef<EditExpenseComponent>,
    private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 
    this.form = this.fb.group({
      expDesc: ['', [Validators.required, Validators.maxLength(30)]],
      expType: ['', [Validators.required]],
      goalType: ['', [Validators.required]],
      growthType: ['', [Validators.required]],
      growthRate: ['', [Validators.required, Validators.min(0), Validators.max(100)]],      
      isAdjToFutureDollar: ['', [Validators.required]],
      startType: ['', [Validators.required]],
      startYr: ['', [Validators.required]],
      startAge: ['', [Validators.required]],
      endType: ['', [Validators.required]],
      endYr: ['', [Validators.required]],
      duration: ['', [Validators.required]],
      endAge: ['', [Validators.required]],
      amount: ['', [Validators.required,  Validators.min(1)]]
    }    
    );
  }

  ngOnInit() {   
    this.startTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.StartType);
    this.endTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.EndType);
    this.infRate = this.refDataService.getKeyValueByCode(fromModel.KEYREF.InflRt);


    this.form.valueChanges.subscribe(fm=>{
      if(fm.amount){
        this.form.patchValue({amount: this.currencyPipe.transform(Utils.getCurrency(fm.amount), 'USD', 'symbol', '1.0-0')}, {emitEvent: false});
      }
    });

    if(this.inputData.expenseId){
      this.mode = "edit"; 
      this.goal = this.dataService.getGoalByExpenseId(this.inputData.expenseId);
      this.goalType = <fromModel.GOALTYPE>this.goal.goalType;
      this.goalTypeDesc = this.goal.goalDesc;
      this.expense = this.dataService.getExpenseByExpenseId(this.inputData.expenseId);       

    } else if(this.inputData.goalId && this.inputData.goalId!==0){ //adding expense by pre-populating goal dropdown
      this.mode = "add";
      this.goal = this.dataService.getGoalByGoalId(this.inputData.goalId);
      this.goalType = <fromModel.GOALTYPE>this.goal.goalType;
      this.goalTypeDesc = this.goal.goalDesc;      

    } else if(this.inputData.goalId===0){ //adding expense by selecting goal from dropdown 
      this.mode = "add";

      if(this.inputData.expType === fromModel.EXPENSETYPE.LGY){
        this.goalType = fromModel.GOALTYPE.LGY;    
        this.goalTypeDesc = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Goals, this.goalType).value;         
        this.mode = "goal";
      } else {
        this.goalType = fromModel.GOALTYPE.LIV;     
      }
      

    } else {
      this.mode = "goal";
      if(this.inputData.goalType){
        this.goalType =  <fromModel.GOALTYPE>this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Goals, this.inputData.goalType).code;
        this.goalTypeDesc = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Goals, this.inputData.goalType).value;        
      }
    }
    
    this.populateGoalTypes();
    this.populateExpenseTypes();  
    this.setFormValues();
  }

  private populateGoalTypes(){
    let _goal = this.dataService.getGoalByType(fromModel.GOALTYPE.LGY);
    if(_goal && this.mode!=="edit"){
      this.goalTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals).filter(({code}) => code !== fromModel.GOALTYPE.LGY);
    } else {
      this.goalTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
    }
  }

  private populateExpenseTypes(){
    if(this.goalType === fromModel.GOALTYPE.LGY){
      this.expenseTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses).filter(({code}) => code === fromModel.EXPENSETYPE.LGY); ;  
    } else {
      this.expenseTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses).filter(({code}) => code !== fromModel.EXPENSETYPE.LGY); ;
    }    
  }

  private setFormValues(){
    let desc;
    let type;
    let owner;
    let glType;
    let gType;    
    let gRate;    
    let adjToFutureDollar;
    let startType;
    let startYr;
    let startAge;
    let endType;
    let endYr;
    let endAge;
    let duration;
    let eAmount;

    if(this.mode === "add"){
    //desc = `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Expenses, fromModel.EXPENSETYPE.OTH).value} Expense`;
      desc = `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Expenses, this.inputData.expType).value} Expense`;     
      gType = fromModel.GROWTHTYPE.INF;
    } else if(this.mode === "goal"){
      desc = `${this.goalTypeDesc} Expense`;
      gType = fromModel.GROWTHTYPE.MNF;
    }

    if(this.mode === "add" || this.mode === "goal"){
      //type = fromModel.EXPENSETYPE.OTH;
      type = this.inputData.expType;
      if(!type){
        type = fromModel.EXPENSETYPE.OTH;
      }
      owner = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientid;
      //glType = '';  
      glType = this.goalType;
      gRate = '';
      startType = fromModel.AMOUNTPERIODTYPE.Year;
      startYr = '';
      startAge = '';
      duration = '';
      endType = fromModel.AMOUNTPERIODTYPE.Year;      
      endYr = '';  
      endAge = '';    
      eAmount = '';  
      

      if(this.mode === "goal"){
        if(this.goalType === fromModel.GOALTYPE.LGY){
          type = fromModel.EXPENSETYPE.LGY;
          gType = fromModel.GROWTHTYPE.INF;
          startType = fromModel.AMOUNTPERIODTYPE.AtEnd;
          endType = fromModel.AMOUNTPERIODTYPE.AtEnd;
        }
      }

      if(type === fromModel.EXPENSETYPE.LGY){
        adjToFutureDollar = 'false';  
      } else {
        adjToFutureDollar = 'true';  
      }

      this.validateGrowthType(gType); 
      this.validateYearType(startType,"start");
      this.validateYearType(endType,"end");

    } else { //edit mode

      desc = this.expense.expDesc;
      type = this.expense.expType;
      owner = this.expense.owner;
      glType = this.dataService.getGoalByExpenseId(this.expense.expId).goalType;      
      
      gType = this.expense.growthType;
      if(gType === fromModel.GROWTHTYPE.MNF){ 
        gRate = this.expense.growthRate;      
      } else {
        gRate = '';
      }

      if('isAdjToFutureDollar' in this.expense){
        adjToFutureDollar = this.expense.isAdjToFutureDollar.toString();
      } else {
        adjToFutureDollar = 'true'; 
      }      
      
      startType = this.expense.amtPeriod[0].startType;
      if(startType === fromModel.AMOUNTPERIODTYPE.Year){
        startYr = this.expense.amtPeriod[0].startYr;
      } else {
        startYr = '';
      }      
      if(startType === fromModel.AMOUNTPERIODTYPE.Age){
        startAge = this.expense.amtPeriod[0].startAge;
      } else {
        startAge = '';
      }

      endType = this.expense.amtPeriod[0].endType;
      if(endType === fromModel.AMOUNTPERIODTYPE.Year){
        endYr = this.expense.amtPeriod[0].endYr;
      } else {
        endYr = '';
      }      
      if(endType === fromModel.AMOUNTPERIODTYPE.Age){
        endAge = this.expense.amtPeriod[0].endAge;
      } else {
        endAge = '';
      }

      if(endType === fromModel.AMOUNTPERIODTYPE.Duration){
        duration = this.expense.amtPeriod[0].duration;
      } else {
        duration = '';
      }
      
      eAmount = this.expense.amtPeriod[0].amount; 

      this.validateGrowthType(gType);
      this.validateYearType(startType,"start");      
      this.validateYearType(endType,"end");
    }
    this.form.setValue({
      expDesc: desc,
      expType: type,
      goalType: glType,
      growthType: gType,
      growthRate: gRate,
      isAdjToFutureDollar: adjToFutureDollar,
      startType: startType,
      startYr: startYr,
      startAge: startAge,
      endType: endType,
      endYr: endYr,
      endAge: endAge,
      duration: duration,
      amount: this.currencyPipe.transform(eAmount, 'USD', 'symbol', '1.0-0')
    });
  }

 
  private preparePlanExpense(expenseType: fromModel.EXPENSETYPE){
    let expense: fromModel.Expense = {
      "expId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMEXP),
      "expType": expenseType,
      "expDesc": '',
      "owner": this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientid,
      "growthType": fromModel.GROWTHTYPE.INF,
      "amtPeriod": [
       {
          "startType": fromModel.AMOUNTPERIODTYPE.Year, //Year, AtRet, Age
          "endType": fromModel.AMOUNTPERIODTYPE.AtEnd, //Year, AtRet, Age, AtEnd          
        }
      ], 
      "isIncluded": true
    };
    return expense;
  }

  private prepareGoal(goalType: fromModel.GOALTYPE){
    let goal: fromModel.Goal = { 
      "goalId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMGOAL),
      "goalType": goalType,
      "goalDesc": this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Goals, goalType).value,
      "priority": Number(this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GoalsPriority, goalType).value),
      "isIncluded": true,
      "expenses": [this.expense.expId]
    };    
    return goal;
  }
  
  selectExpenseType(event: any, expType: fromModel.Expense){
    if(event.isUserInput){      
    }
  }
  
  selectGrowthType(growthType){
    this.validateGrowthType(growthType);
  }

  selectYearType(event: any, amountPeriodType: fromModel.AMOUNTPERIODTYPE, yearType){     
    if(event.isUserInput){
      this.validateYearType(amountPeriodType,yearType);
    }
  }

  selectGoalType(event: any, goalType: fromModel.GOALTYPE){     
    if(event.isUserInput){
      this.goalType = goalType;
      this.populateExpenseTypes();   
      if(goalType === fromModel.GOALTYPE.LGY){
        //this.form.patchValue({expDesc: `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Expenses, fromModel.EXPENSETYPE.LGY).value} Expense`});
        this.form.patchValue({expType: fromModel.EXPENSETYPE.LGY});
        this.form.patchValue({startType: fromModel.AMOUNTPERIODTYPE.AtEnd});
        this.form.patchValue({endType: fromModel.AMOUNTPERIODTYPE.AtEnd});        
        this.validateYearType(fromModel.AMOUNTPERIODTYPE.AtEnd,"start");
        this.validateYearType(fromModel.AMOUNTPERIODTYPE.AtEnd,"end");      
      } else {
        //this.form.patchValue({expDesc: `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Goals, goalType).value} Expense`});        
      }

    }
  }

  private clearValidators(field){
    this.form.controls[field].setErrors(null);    
    this.form.controls[field].clearValidators();
    this.form.controls[field].updateValueAndValidity();
  }

  private setValidators(field, validators: ValidatorFn[]){
    this.form.controls[field].setValidators(validators);
    this.form.controls[field].updateValueAndValidity();
  }

  private validateYearType(amountPeriodType: fromModel.AMOUNTPERIODTYPE, yearType){
    let yrField;
    let ageField;
    let durationField;

    if(yearType === 'start'){
      yrField = "startYr";
      ageField = "startAge";
    } else {
      yrField = "endYr";
      ageField = "endAge";
      durationField = "duration";
    }

    if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.AtRet 
      || amountPeriodType === fromModel.AMOUNTPERIODTYPE.AtEnd){
      this.clearValidators(yrField);
      this.clearValidators(ageField);
      if(durationField){
        this.clearValidators(durationField);        
      }
    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Duration){
      this.setValidators(durationField, [Validators.required]);
      this.clearValidators(yrField);      
      this.clearValidators(ageField);

    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Age){
      this.setValidators(ageField, [Validators.required]);
      this.clearValidators(yrField);      
      if(durationField){
        this.clearValidators(durationField);        
      }
    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Year){
      this.setValidators(yrField, [Validators.required]);
      this.clearValidators(ageField);      
      if(durationField){
        this.clearValidators(durationField);        
      }
    }
  }


  private validateDuration(){
    let isValid=true;
    if(this.form.get('expType').value !== fromModel.EXPENSETYPE.LGY){
      if(this.form.get('startType').value === fromModel.AMOUNTPERIODTYPE.Year
      && this.form.get('endType').value === fromModel.AMOUNTPERIODTYPE.Year)
      {      
        if(Number(this.form.get('startYr').value)>=Number(this.form.get('endYr').value)){
          isValid=false;
          this.validationMsg = Constant.ErrorMsgs.durationErrorMsg;
        }      
      } else if(this.form.get('startType').value === fromModel.AMOUNTPERIODTYPE.Age
      && this.form.get('endType').value === fromModel.AMOUNTPERIODTYPE.Age)
      {      
        if(Number(this.form.get('startAge').value)>=Number(this.form.get('endAge').value)){
          isValid=false;
          this.validationMsg = Constant.ErrorMsgs.durationErrorMsg;
        }      
      }
    }
    return isValid;
  }
  
  private validateGrowthType(growthType){
    if(growthType === fromModel.GROWTHTYPE.INF){
      this.form.patchValue({growthRate: ''});
      this.form.controls["growthRate"].setErrors(null);    
      this.form.controls["growthRate"].clearValidators();
      this.form.controls["growthRate"].updateValueAndValidity();
    } else {
      this.form.controls["growthRate"].setValidators(Validators.required);
      this.form.controls["growthRate"].updateValueAndValidity();
    }
  }

  saveExpense(): void {
    if(this.form.valid && this.validateDuration()){
      //console.log(this.form.getRawValue()); 
      let _goal = this.dataService.getGoalByType(this.form.get('goalType').value);
      if(_goal){
        this.goal = _goal;
      } else {
        this.goalType = <fromModel.GOALTYPE>this.form.get('goalType').value;
        this.mode = "goal";
      }

      if(!this.expense){
        this.expense =  this.preparePlanExpense(this.form.get('expType').value);
      }


      this.expense.expDesc = this.form.get('expDesc').value;
      this.expense.expType = this.form.get('expType').value;      
      //this.expense.owner =   this.expenseOwner.clientid;

      this.expense.growthType = this.form.get('growthType').value;

      if(this.expense.growthType === fromModel.GROWTHTYPE.MNF){
        this.expense.growthRate = this.form.get('growthRate').value;
      }
    
      this.expense.isAdjToFutureDollar = (this.form.get('isAdjToFutureDollar').value === "true"); 

      this.expense.amtPeriod[0].startType = this.form.get('startType').value;
      if(this.expense.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Year){
        this.expense.amtPeriod[0].startYr = this.form.get('startYr').value;        
      } else if(this.expense.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Age){
        this.expense.amtPeriod[0].startAge = this.form.get('startAge').value;
      }
     
      this.expense.amtPeriod[0].endType = this.form.get('endType').value;
      if(this.expense.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Year){
        this.expense.amtPeriod[0].endYr = this.form.get('endYr').value;
      } else if(this.expense.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Age){
        this.expense.amtPeriod[0].endAge = this.form.get('endAge').value;
      } else if(this.expense.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Duration){
        this.expense.amtPeriod[0].duration = this.form.get('duration').value; 
      }
      
      //this.expense.amtPeriod[0].amount = this.form.get('amount').value;
      this.expense.amtPeriod[0].amount = Utils.getNumber(this.form.get('amount').value);


      if(this.mode === "edit"){
        this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATEEXPENSE, "EditExpenseComponent-saveExpense-UpdateExistingExpense", {expense: this.expense, goalId: this.goal.goalId});
      } else if(this.mode === "add"){ 
        this.dataService.dispatchAction(fromModel.DATA_ACTION.ADDEXPENSE, "EditExpenseComponent-saveExpense-CreateNewExpense", {expense: this.expense, goalId: this.goal.goalId});
      }else if(this.mode === "goal"){
        let _goal = this.prepareGoal(this.goalType);
        this.dataService.dispatchAction(fromModel.DATA_ACTION.CREATEGOAL, "EditExpenseComponent-saveExpense-CreateGoalExpense", {expense: this.expense, goal: _goal});
      }
      this.dataService.savePlan();
      this.closeDialog(true);
    } else {
      console.log('There is a problem with the form.');
    }
  }

  deleteExpense(): void {
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEEXPENSE);    
  }

  private openModelDialog(action: fromModel.OPENDIALOGACTIONS){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.DELETEEXPENSE: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Expense, name: this.expense.expDesc}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEEXPENSE, "EditExpenseComponent-deleteExpense", {expense: this.expense, goalId: this.goal.goalId});
            this.dataService.savePlan();
            this.closeDialog(true);
          }
        });
        break;
      }     
    }
  }

  closeDialog(saved: boolean | false): void {
    this.dialogRef.close({isSaved: saved, expense: this.expense});
  }

  ngOnDestroy(): void{    
 }

}
